import useSound from 'use-sound';
import type { HookOptions } from 'use-sound/dist/types';
import { useMute } from '@/hooks/useMute';

export const useOnlybotsSound = <T,>(src: string | string[], options?: HookOptions<T>): ReturnType<typeof useSound> => {
    const { soundEnabled } = useMute();

    return useSound(src, {
        soundEnabled,
        ...(options ?? {}),
    });
};
